<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Zoho Crm" class="d-icon d-icon--zoho-crm" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M6.617 6.15c-1.628.394-3.198 1.66-3.942 3.18C2.23 10.242 2 11.178 2 12.092c0 2.794 2 5.323 4.711 5.958.834.195 2.58.15 3.116-.08.391-.168.54-.495.368-.815-.144-.27-.427-.335-.843-.194-.195.066-.741.12-1.212.12-2.078.001-3.88-1.225-4.679-3.18-.338-.829-.423-2.265-.183-3.101a5.095 5.095 0 0 1 2.666-3.186c1.65-.796 3.396-.695 4.88.283.305.2 1.423 1.239 2.485 2.307 1.65 1.66 1.94 1.994 1.988 2.294.05.31.019.39-.279.687-.354.354-.673.423-1.051.229-.115-.06-1.023-.91-2.018-1.892-1.7-1.676-1.84-1.791-2.31-1.902-1.517-.359-2.812.911-2.496 2.448.112.544.126.56 2.22 2.67 1.238 1.247 2.352 2.282 2.699 2.508 1.71 1.114 4.142 1.26 5.972.357 1.643-.81 2.902-2.365 3.306-4.083.159-.673.159-2.184 0-2.857-.5-2.126-2.352-3.986-4.492-4.512-1.107-.273-3.035-.158-3.447.205-.25.22-.213.653.073.84.213.14.291.143.69.028.704-.202 1.956-.159 2.708.094 2.085.7 3.506 2.635 3.506 4.774 0 1.339-.491 2.505-1.469 3.486-1.046 1.05-2.11 1.504-3.531 1.504-.939 0-1.537-.154-2.436-.625-.779-.409-4.755-4.405-4.755-4.78 0-.79.81-1.267 1.439-.846.136.091 1.005.925 1.931 1.852 1.52 1.523 1.734 1.703 2.2 1.85a2.028 2.028 0 0 0 2.645-1.973c-.003-.338-.074-.667-.196-.904-.107-.208-1.138-1.307-2.32-2.474-1.896-1.872-2.21-2.142-2.89-2.489-.418-.213-1.043-.458-1.386-.542-.769-.19-2.21-.19-2.993 0Z" fill="#3779B9"/></svg>
</template>

<script>
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconZohoCrm',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
  },
};
</script>
